import { getStage } from './stage'
import environment from './environment'

export default {
  getStage,
  ...environment,
}
